import styled, { css } from 'styled-components';

export const InsightsIconContainer = styled.button`
  display: flex;
  position: relative;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    transform: scale(1.25);
  }

  &:disabled {
    pointer-events: none;
  }
`;

const readStateStyles = css`
  color: var(--text-soft);

  svg > svg:first-of-type {
    fill: var(--surface-default);
    stroke: var(--icon-soft);
  }

  svg > g svg {
    fill: var(--icon-soft);
  }
`;

export const ScenarioIconWrapper = styled.div<{ $isRead: boolean }>`
  display: inline-flex;
  ${({ $isRead }) => $isRead && readStateStyles}
`;
